import type {FinishedActionResponse, IdentifiedFile, Rec} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';

interface SetFileAsPrimaryCoverParams {
    record: Rec;
    file: IdentifiedFile;
}

export class RecordCoverDataService {
    public static serviceName = 'recordCoverDataService';

    public static readonly SET_COVER_ROUTE = 'records/covers/primary/set';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async setFileAsPrimaryCover(params: SetFileAsPrimaryCoverParams): Promise<FinishedActionResponse> {
        return this.ajaxService
            .createRequest(`${RecordCoverDataService.SET_COVER_ROUTE}`)
            .post(transferify(params));
    }
}